export const IsLoged = 'IsLoged';
export const Affiliate = 'affid';